// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__10F5r","description":"PatientConsentPreview_description__Ec0jN"};